import { MouseEvent } from 'react'

export const preventDefault = (e: MouseEvent<HTMLElement>) => {
  e.preventDefault()
}
